import { PropsWithChildren } from "react";
import "./InfoPanel.scss";

const InfoPanel = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
    <div className={`infoPanel ${className}`}>
        <div className="infoPanel__content">{children}</div>
    </div>
);

InfoPanel.Title = ({ children }: PropsWithChildren<{}>) => (
    <div className="infoPanel__title text-lg text-bold">{children}</div>
);

InfoPanel.Label = ({ children }: PropsWithChildren<{}>) => (
    <div className="infoPanel__label text-xs text-dark-grey">{children}</div>
);

InfoPanel.Value = ({ children }: PropsWithChildren<{}>) => (
    <div className="infoPanel__value text-sm">{children}</div>
);

InfoPanel.SingleValue = ({ children }: PropsWithChildren<{}>) => (
    <div className="infoPanel__label">{children}</div>
);

export default InfoPanel;
